import { Controller } from '@hotwired/stimulus';
import { getCookie } from '../get_cookie';

export default class extends Controller {
  static values = {
    products: Array,
    subtotalAmount: String,
    bookingNumber: String,
    voucherCode: String
  };

  connect() {
    const emid = getCookie('emid');

    // AWIN conversionTag
    /*** Do not change ***/
    window.AWIN = window.AWIN || {};
    window.AWIN.Tracking = window.AWIN.Tracking || {};
    window.AWIN.Tracking.Sale = {};
    /*** Set your transaction parameters ***/
    window.AWIN.Tracking.Sale.amount = this.subtotalAmountValue;
    window.AWIN.Tracking.Sale.channel = 'aw';
    window.AWIN.Tracking.Sale.orderRef = this.bookingNumberValue;
    window.AWIN.Tracking.Sale.parts = `DEFAULT:${this.subtotalAmountValue}`;
    window.AWIN.Tracking.Sale.currency = 'EUR';
    window.AWIN.Tracking.Sale.voucher = this.voucherCodeValue;
    window.AWIN.Tracking.Sale.test = !!emid ? '0' : '1';
    // This triggers an GTM event to load the awin master tag.
    window.dataLayer && window.dataLayer.push({ event: 'payment:success' });

    const script = document.createElement('script');
    script.src = 'https://trck.picturepeople.de/trck/ebasket/ebasket.js';
    document.body.append(script);

    script.addEventListener('load', () => {
      if (!emid) return;

      this.productsValue.forEach((obj) => {
        eamTrckAddBasketItem(
          obj.campaign_id,
          obj.token,
          obj.trigger_id,
          obj.article_number,
          obj.amount,
          obj.price,
          emid,
          obj.product_name,
          obj.category,
          obj.custom
        );
      });

      eamTrckSubmitBasket();
    });
  }
}
